import * as types from './mutations-type'

export const setDisplayDashboard = function({commit}, payload) {
    commit(types.DISPLAY_DASHBOARD, payload)
}
export const setDisplayDashboard2019 = function({commit}, payload) {
    commit(types.DISPLAY_SPACY, payload)
}

